import styled from 'styled-components';

export const colors = {
  primary: '#112369',
  secondary: '#b5b5b5',
  lightGray: 'rgba(0, 0, 0, 0.04)',
  lightBlue: '#1e88e5',
  alarm: {
    red: '#f72c2c',
    orange: '#ff9d52',
    yellow: '#e5d511',
    black: '#101010',
    unknown: 'gray'
  },
};

export const theme = {
  divider: colors.lightGray,
  infoSubtitle: colors.primary,
  infoTitle: colors.secondary,
  label: colors.primary,
  sectionTitle: colors.primary,
  colors,
  select: {
    main: colors.lightBlue,
    placeholder: 'white',
    indicator: 'white',
    indicatorHover: colors.primary,
    selected: 'white',
    menuOption: colors.primary,
  },
  sideBar: colors.primary,
  text: colors.primary,
};

export const Page = styled.div`
  height: 100%;
`;
